import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";

export const RecentBlogsSection = ({ blogs = [] }) => {
  if (blogs.length === 0) {
    return null;
  }

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  return (
    <section data-testid="recent-blogs-section" className="section-padding bg-its-teal-dark">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12"
        >
          <div>
            <span className="label-text">News & Views</span>
            <h2 className="heading-2 mt-2">Latest Insights</h2>
          </div>
          <Link
            to="/news"
            onClick={() => window.scrollTo({ top: 0 })}
            data-testid="view-all-blogs"
            className="text-its-gold hover:text-its-gold-soft flex items-center gap-2 text-sm font-medium transition-colors"
          >
            View All Posts
            <ArrowRight size={16} />
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {blogs.map((blog, index) => (
            <motion.article
              key={blog.id || index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass-card group hover:-translate-y-1 transition-all duration-300"
            >
              {blog.featured_image && (
                <div className="relative h-48 mb-4 -mx-6 -mt-6 md:-mx-8 md:-mt-8 overflow-hidden rounded-t-xl">
                  <img
                    src={blog.featured_image}
                    alt={blog.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              )}
              <div className="flex items-center gap-2 text-xs text-its-teal-light mb-3">
                <Calendar size={14} />
                <time>{formatDate(blog.created_at)}</time>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-its-gold transition-colors">
                <Link to={`/news/${blog.slug}`}>{blog.title}</Link>
              </h3>
              <p className="text-its-offwhite/80 text-sm line-clamp-3 mb-4">
                {blog.excerpt}
              </p>
              {blog.topics && blog.topics.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {blog.topics.map((topic) => (
                    <span
                      key={topic}
                      className="text-xs px-2 py-1 rounded-full bg-its-teal-light/20 text-its-teal-light"
                    >
                      {topic.replace("-", " ")}
                    </span>
                  ))}
                </div>
              )}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
